import React from "react";
import { Dialog, DialogContent, Box, Typography, IconButton, Avatar, alpha } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import UpdateUserForm from "./UpdateUserForm";

const ACCENT = "#1976d2";

const EditUserDialog = ({ user, open, onClose, ...updateUserFormProps }) => {
  if (!user) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth PaperProps={{ sx: { borderRadius: 4, overflow: "hidden" } }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          px: 3,
          py: 2,
          background: `linear-gradient(135deg, ${ACCENT} 0%, ${alpha(ACCENT, 0.75)} 100%)`,
          color: "#fff",
        }}
      >
        <Box display="flex" alignItems="center" gap={1.5}>
          <Avatar sx={{ bgcolor: "rgba(255,255,255,0.18)", width: 38, height: 38, fontWeight: 700 }}>
            {user.Name?.charAt(0) || "?"}
          </Avatar>
          <Box>
            <Typography variant="subtitle1" fontWeight={700}>
              עריכת משתמש
            </Typography>
            <Typography variant="body2" sx={{ opacity: 0.9 }}>
              {user.Name} {user.LastName}
            </Typography>
          </Box>
        </Box>
        <IconButton size="small" onClick={onClose} sx={{ color: "#fff" }}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>

      <DialogContent sx={{ bgcolor: "#fafafa", p: 4 }}>
        <UpdateUserForm user={user} onCancel={onClose} {...updateUserFormProps} />
      </DialogContent>
    </Dialog>
  );
};

export default EditUserDialog;
